import React, { useEffect } from 'react'
import '../../assets/css/salesforce.css'

const Odoo = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="breadcrumb-title">
                                    Odoo ERP Solutions
                                </h1>
                                <p className="breadcrumb-subtitle text-white">
                                    Comprehensive Odoo implementation, customization, and support services to streamline your business operations<br /> and drive digital transformation with the world's leading open-source ERP platform.
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            <section className="ai-driven-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="ai-driven-content">
                                <h2 className="ai-driven-title" style={{ textAlign: 'left' }}>
                                    <span className="text-gradient">Our Odoo</span> Services
                                </h2>
                                <p className="ai-driven-description">
                                    CLOUD MIND X delivers end-to-end Odoo solutions, from initial consultation and implementation to ongoing support and optimization. As certified Odoo partners, we leverage deep expertise to help organizations harness the full potential of Odoo ERP and achieve operational excellence across all business functions.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="ai-driven-image-wrapper">
                                <img
                                    src={require('../../assets/images/odoo.webp')} // Placeholder - replace with Odoo image
                                    alt="Odoo ERP"
                                    className="ai-driven-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Odoo Services Section */}
            <section className="salesforce-services-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center mb-5">
                            <h2 className="salesforce-services-title">
                                Our <span className="text-gradient">Odoo Services</span>
                            </h2>
                            <p className="salesforce-services-subtitle">
                                Complete Odoo solutions designed to optimize your business processes and accelerate growth
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        {/* Service Card 1 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 17L12 22L22 17" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 12L12 17L22 12" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Odoo Consulting</h3>
                                <p className="sf-service-description">
                                    Strategic guidance to align Odoo with your business objectives. Our consultants analyze your current processes, identify optimization opportunities, and develop a comprehensive roadmap for successful Odoo implementation and digital transformation.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 2 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21 16V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18H19C20.1046 18 21 17.1046 21 16Z" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M12 6V18" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M3 12H21" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Odoo Implementation</h3>
                                <p className="sf-service-description">
                                    Seamless deployment of Odoo tailored to your specific business requirements. From initial setup and configuration to data migration and user training, we ensure a smooth transition and rapid adoption of your new ERP system.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 3 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 17L12 22L22 17" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 12L12 17L22 12" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Odoo Customization</h3>
                                <p className="sf-service-description">
                                    Tailor Odoo to perfectly fit your business processes. We customize modules, workflows, and user interfaces to match your unique requirements, ensuring maximum efficiency and user adoption across your organization.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 4 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="4" y="4" width="16" height="16" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M8 2V6" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M16 2V6" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4 10H20" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Custom Odoo Development</h3>
                                <p className="sf-service-description">
                                    Build custom modules and applications on the Odoo platform. Our developers create powerful, scalable solutions using Python, XML, and JavaScript to extend Odoo functionality and integrate with third-party systems.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 5 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21 12C21 16.9706 16.9706 21 12 21M21 12C21 7.02944 16.9706 3 12 3M21 12H3M12 21C7.02944 21 3 16.9706 3 12M12 21C13.6569 21 15 16.9706 15 12C15 7.02944 13.6569 3 12 3M12 21C10.3431 21 9 16.9706 9 12C9 7.02944 10.3431 3 12 3M3 12C3 7.02944 7.02944 3 12 3" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Odoo Integration</h3>
                                <p className="sf-service-description">
                                    Seamlessly integrate Odoo with your existing systems and applications. We provide robust integration solutions for e-commerce platforms, payment gateways, shipping systems, and enterprise applications to create a unified ecosystem.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 6 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="12" r="3" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M12 1V3" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M12 21V23" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4.22 4.22L5.64 5.64" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M18.36 18.36L19.78 19.78" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M1 12H3" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M21 12H23" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4.22 19.78L5.64 18.36" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M18.36 5.64L19.78 4.22" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Odoo Support & Maintenance</h3>
                                <p className="sf-service-description">
                                    Comprehensive support services to keep your Odoo system running optimally. We provide 24/7 technical assistance, regular updates, performance monitoring, and continuous improvements to ensure maximum ROI from your ERP investment.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 7 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M12 22V12" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M7 9.5L2 12V17L12 22L22 17V12L17 9.5" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Odoo Training</h3>
                                <p className="sf-service-description">
                                    Empower your team with comprehensive Odoo training programs. We offer end-user training, administrator training, and developer training to ensure your staff can effectively utilize and maintain the Odoo system.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 8 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21 12C21 16.9706 16.9706 21 12 21M21 12C21 7.02944 16.9706 3 12 3M21 12H3M12 21C7.02944 21 3 16.9706 3 12M12 21C13.6569 21 15 16.9706 15 12C15 7.02944 13.6569 3 12 3M12 21C10.3431 21 9 16.9706 9 12C9 7.02944 10.3431 3 12 3M3 12C3 7.02944 7.02944 3 12 3" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Odoo Migration</h3>
                                <p className="sf-service-description">
                                    Smooth migration from legacy systems to Odoo. We handle data migration, system upgrades, and process transitions while minimizing downtime and ensuring data integrity throughout the migration process.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* Odoo Modules Expertise Section */}
            <section className="salesforce-clouds-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center mb-3">
                            <h2 className="salesforce-clouds-title">
                                Odoo Modules <span className="text-gradient">We Cover</span>
                            </h2>
                            <p className="salesforce-clouds-subtitle">
                                Deliver a personalized Odoo experience that seamlessly integrates with your organization's goals and operational requirements.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        {/* Sales */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#00D4FF" />
                                        <path d="M18 24L22 28L30 20" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Sales</h3>
                            </div>
                        </div>

                        {/* CRM */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#FF6B9D" />
                                        <path d="M24 14C28.4183 14 32 17.5817 32 22C32 26.4183 28.4183 30 24 30C19.5817 30 16 26.4183 16 22C16 17.5817 19.5817 14 24 14Z" stroke="white" strokeWidth="2.5" />
                                        <path d="M24 30V34" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">CRM</h3>
                            </div>
                        </div>

                        {/* Accounting */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#00A1E0" />
                                        <path d="M14 24L20 18L26 24L34 16" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M28 16H34V22" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Accounting</h3>
                            </div>
                        </div>

                        {/* Inventory */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#A78DFF" />
                                        <circle cx="24" cy="18" r="4" stroke="white" strokeWidth="2.5" />
                                        <circle cx="16" cy="28" r="3" stroke="white" strokeWidth="2.5" />
                                        <circle cx="32" cy="28" r="3" stroke="white" strokeWidth="2.5" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Inventory</h3>
                            </div>
                        </div>

                        {/* Manufacturing */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#8B5CF6" />
                                        <path d="M16 20H32M16 20V30H32V20M16 20L24 14L32 20" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M20 26V30" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                        <path d="M24 26V30" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                        <path d="M28 26V30" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Manufacturing</h3>
                            </div>
                        </div>

                        {/* HR */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#FFA726" />
                                        <path d="M24 14L19 19V32H29V19L24 14Z" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M19 22H29" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">HR</h3>
                            </div>
                        </div>

                        {/* Project */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#00A8E1" />
                                        <circle cx="24" cy="24" r="8" stroke="white" strokeWidth="2.5" />
                                        <path d="M24 16V14M24 34V32M16 24H14M34 24H32" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Project</h3>
                            </div>
                        </div>

                        {/* eCommerce */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#10B981" />
                                        <path d="M16 18L20 14L24 18L28 14L32 18V30C32 31.1046 31.1046 32 30 32H18C16.8954 32 16 31.1046 16 30V18Z" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">eCommerce</h3>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="salesforce-contact-section">
                <div className="salesforce-contact-overlay"></div>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-8">
                            <div className="salesforce-contact-content">
                                <h2 className="salesforce-contact-title">Get in touch</h2>
                                <p className="salesforce-contact-description">
                                    Ready to transform your business operations with Odoo ERP? Contact our certified consultants to discover how Odoo can streamline your processes and drive growth.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 text-center text-lg-end">
                            <button className="salesforce-contact-btn">
                                Contact us
                            </button>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default Odoo;
